@if (loadState === 'loading') {
<div class="state" role="status">
    <mat-icon class="spin">progress_activity</mat-icon>
    <span>Carregando controlador...</span>
</div>
} @else if (loadState === 'error') {
<div class="state error" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>Não foi possível carregar os dados do controlador.</span>
    <button type="button" mat-stroked-button (click)="loadController()">Tentar novamente</button>
</div>
} @else if (controller) {
    @switch (view) {
        @case ('painel') {
            <homeleite-controller-work [controller]="controller"></homeleite-controller-work>
        }

        @case ('vincular') {
            <section class="view-head">
                <h2>Vincular Produtores</h2>
                <p>Busque um produtor pelo nome ou código para vinculá-lo a este controlador.</p>
            </section>

            <div class="link-grid">
                <section class="card">
                    <h3>Adicionar produtor</h3>
                    <mat-form-field appearance="outline" class="search-field">
                        <mat-label>Buscar produtor</mat-label>
                        <input
                            matInput
                            [formControl]="producerSearchCtrl"
                            [matAutocomplete]="auto"
                            placeholder="Nome ou código"
                        />
                        <mat-icon matPrefix>search</mat-icon>
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onProducerSelected($event)">
                            @for (producer of filteredProducers$ | async; track producer?.id) {
                                <mat-option [value]="producer" class="producer-option">
                                    <div class="option-wrapper">
                                        <span class="option-code">{{ producer?.code }}</span>
                                        <span class="option-name">{{ producer?.name }}</span>
                                    </div>
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </section>

                <section class="card">
                    <div class="card-head">
                        <h3>Produtores vinculados</h3>
                        @if (controller.activeProducers?.length) {
                            <span class="count-badge">{{ controller.activeProducers?.length }}</span>
                        }
                    </div>

                    @if (controller.activeProducers?.length) {
                        <div class="producers-list">
                            @for (producer of controller.activeProducers; track producer?.id) {
                                <div class="producer-item">
                                    <div class="item-code">{{ producer?.code }}</div>
                                    <p class="item-name">{{ producer?.name }}</p>
                                    <button
                                        type="button"
                                        mat-icon-button
                                        color="warn"
                                        class="remove-action"
                                        (click)="onProducerRemoved(producer)"
                                        [attr.aria-label]="'Remover ' + producer?.name"
                                        title="Remover"
                                    >
                                        <mat-icon>delete_outline</mat-icon>
                                    </button>
                                </div>
                            }
                        </div>
                    } @else {
                        <div class="empty-state">
                            <mat-icon class="empty-icon">group_off</mat-icon>
                            <h4>Nenhum produtor vinculado</h4>
                            <p>Use o campo ao lado para adicionar um produtor.</p>
                        </div>
                    }
                </section>
            </div>
        }

        @case ('historico') {
            <section class="view-head">
                <h2>Histórico de Controles</h2>
                <p>Eventos e ocorrências registrados para este controlador.</p>
            </section>
            <article class="card">
                @if (historyState === 'loading') {
                <div class="state" role="status">
                    <mat-icon class="spin">progress_activity</mat-icon>
                    <span>Carregando controles…</span>
                </div>
                } @else if (historyState === 'error') {
                <div class="state error" role="alert">
                    <mat-icon>error_outline</mat-icon>
                    <span>Não foi possível carregar o histórico.</span>
                    <button type="button" mat-stroked-button (click)="loadHistory()">Tentar novamente</button>
                </div>
                } @else if (!history.length) {
                <div class="state">Nenhum controle deste controlador ainda.</div>
                } @else {
                <div class="table-wrap">
                    <table>
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Produtor</th>
                                <th>Animais</th>
                                <th>Envio</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of history; track row.id) {
                            <tr class="row" tabindex="0" role="button" title="Ver controle" (click)="onOpen(row)" (keydown.enter)="onOpen(row)">
                                <td>
                                    <b>{{ formatDay(row.day) }}</b>
                                    <small>{{ row.status === 'OPEN' ? 'Aberto' : 'Finalizado' }}{{ row.official ? ' · Oficial' : '' }}</small>
                                </td>
                                <td>
                                    <b>{{ row.producerName }}</b>
                                    <small>Código {{ row.producerCode || '—' }}</small>
                                </td>
                                <td>
                                    <b>{{ row.animals }}</b>
                                    <small>{{ row.milkingsCount || row.milkings?.length || 0 }} ordenhas</small>
                                </td>
                                <td>{{ syncText(row.sync) }}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                }
            </article>
        }
    }
}
